import { Component, OnInit } from '@angular/core';
import { UtilityService } from '../../services/utility-service';

@Component({
  // selector: 'app-loader',
  // templateUrl: './loader.component.html',
  // styleUrls: ['./loader.component.css']
  selector: 'app-loader',
  template: `
    <div *ngIf="loading | async" class="loader-overlay">
      <div class="loader-container">
        <div class="spinner"></div>
        <div class="loader-text">Loading...</div>
      </div>
    </div>
  `,
  styles: [`
    .loader-overlay {
      position: fixed;
      inset: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.4);
      backdrop-filter: blur(5px);
      -webkit-backdrop-filter: blur(5px);
      z-index: 9999;
      animation: fadeIn 0.3s ease-out;
    }
    .loader-container {
      background: rgba(255, 255, 255, 0.85);
      padding: 24px 40px;
      border-radius: 16px;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      border: 1px solid rgba(255, 255, 255, 0.5);
    }
    .spinner {
      position: relative;
      width: 48px;
      height: 48px;
      border: 3px solid transparent;
      border-top-color: #0f172a;
      border-bottom-color: #4f46e5;
      border-radius: 50%;
      animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    }
    .spinner::before {
      content: "";
      position: absolute;
      top: 6px;
      left: 6px;
      right: 6px;
      bottom: 6px;
      border: 3px solid transparent;
      border-left-color: #4f46e5;
      border-right-color: #0f172a;
      border-radius: 50%;
      animation: spin 1s cubic-bezier(0.5, 0, 0.5, 1) infinite reverse;
    }
    .loader-text {
      font-size: 13px;
      font-weight: 800;
      letter-spacing: 0.15em;
      text-transform: uppercase;
      background: linear-gradient(90deg, #0f172a, #4f46e5);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: pulseText 2s infinite;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    @keyframes pulseText {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.6; }
    }
    @keyframes fadeIn {
      from { opacity: 0; backdrop-filter: blur(0px); }
      to { opacity: 1; backdrop-filter: blur(5px); }
    }
  `]
})
export class LoaderComponent implements OnInit {

  loading = this.l_UtilityService.loading$;

  constructor(private l_UtilityService: UtilityService) { }

  ngOnInit(): void {
  }

}
